// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upgrade[data-v-5ec51a2e]{color:#ffba00}.ib-icon-info[data-v-5ec51a2e]{opacity:.4}.ib-icon-info[data-v-5ec51a2e]:hover{opacity:.8}", ""]);
// Exports
module.exports = exports;
